module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page clients",
    class: {
      init: _vm.isInit
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row center-xs success"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-xs-12 case-studies"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('router-link', {
    attrs: {
      "to": "/ruggedian-case-study"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../img/ruggedian-main.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Pune Get’s Rugged!")]), _vm._v(" "), _c('p', [_vm._v("Explore now")]), _vm._v(" "), _c('span')]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/qaudio-case-study"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../img/qaudio-main.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Helping Indians Tune in To Happiness")]), _vm._v(" "), _c('p', [_vm._v("Explore now")]), _vm._v(" "), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('router-link', {
    attrs: {
      "to": "/lebenor-case-study"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../img/lebenor-main.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Embracing the evolution of living spaces")]), _vm._v(" "), _c('p', [_vm._v("Explore now")]), _vm._v(" "), _c('span')]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/ubob-case-study"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../img/ubob-main.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Amping it up with Millennials and Vodafone U")]), _vm._v(" "), _c('p', [_vm._v("Explore now")]), _vm._v(" "), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('router-link', {
    attrs: {
      "to": "/expro-case-study"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../img/Expro_banner_Img.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("EXPRO !")]), _vm._v(" "), _c('p', [_vm._v("Explore now")]), _vm._v(" "), _c('span')])], 1)])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row center-xs contact-btn"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12 text-center"
  }, [_c('router-link', {
    staticClass: "next",
    attrs: {
      "to": "/contact"
    }
  }, [_c('span', [_vm._v("Connect to Create")])]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "scroll-btn"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 477.175 477.175"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 477.175 477.175",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12 text-center first"
  }, [_c('h1', [_vm._v("100%")]), _c('span', [_vm._v("COMMITTED")]), _vm._v(" "), _c('p', [_vm._v("Across the years, we’ve partnered with brands across verticals and domains, and some even from outer space (or at least we thought so because they were so wonderful.)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs icons"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('h2', [_vm._v("Clients")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../img/clients-shadow.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-37.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-36.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-35.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-34.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-33.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-32.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-31.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-30.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-29.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-28.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-27.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-26.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-25.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-24.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-23.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-22.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-21.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-20.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-19.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-18.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-17.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-16.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-15.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-14.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-13.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-12.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-11.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-10.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-9.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-8.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-7.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-6.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-5.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-4.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-3.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-2.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": require("../img/clients-icon-1.png")
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('h3', [_vm._v("Success")]), _vm._v(" "), _c('h2', [_vm._v("Stories")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs last"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('p', [_vm._v("If you’re looking for fresh and impactful solutions,"), _c('br'), _vm._v("we’re your guys.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2fe4376"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clients.vue
// module id = 166
// module chunks = 0